module.exports = "h5{line-height:normal}img{width:110px}.registered-container{margin:auto;text-align:center;width:360px}iframe{height:0}\n"